/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { GET_APPLICATION, GET_MY_ORG_PROFILE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { toHeaderCase } from 'js-convert-case';
import { featuresSection } from '../../config/featuresSection.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';
import moment from 'moment-timezone';
import { apiConfig } from '@/config/apiConfig';
//@ts-ignore
import { v4 as uuidv4 } from 'uuid';

export interface IGetProfileMethods extends IPluginMethodMap {
  getProfile(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetProfileService implements IAgentPlugin {
  readonly methods: IGetProfileMethods;

  constructor() {
    this.methods = {
      getProfile: this.getProfile.bind(this),
    };
  }

  private async getProfile(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    try {
      if (client) {
        console.log(client);
        const res = await client.query(GET_MY_ORG_PROFILE, {});
        console.log('ress->profile', res);
        if (res?.data?.getMyProfile) {
          // storageService?.set(
          //   'myProfile',
          //   {
          //     ...res?.data?.getMyProfile,
          //     type: res?.data?.getMyProfile?.trn ? 'company' : 'roe',
          //   },
          //   'session'
          // );
          console.log(
            'attempt-->001',
            res?.data?.getMyProfile?.org?.setUpApplicationNo
          );
          const appno = res?.data?.getMyProfile?.org?.setUpApplicationNo;
          let docs = [];
          let getapp = {};
          if (appno) {
            const ress = await client.query(GET_APPLICATION, {
              applicationNo: appno,
            });
            if (ress?.data?.getApplication) {
              docs = ress?.data?.getApplication?.documents;
              getapp = ress?.data?.getApplication;
              storageService?.set(
                'myProfile',
                {
                  ...res?.data?.getMyProfile,
                  type:
                    res?.data?.getMyProfile?.org?.orgRole ===
                    'CARICOM_BUSSINESS_ORG'
                      ? 'roe'
                      : 'company',
                  natureOfBusiness:
                    ress?.data?.getApplication?.applicantInfo?.natureOfBusiness,
                  nationality:
                    ress?.data?.getApplication?.applicantInfo?.nationality,
                  documents: ress?.data?.getApplication?.documents,
                },
                'session'
              );
            }
            console.log('ress-->egtasklsad', ress);
          } else {
            storageService?.set(
              'myProfile',
              {
                ...res?.data?.getMyProfile,
                type: res?.data?.getMyProfile?.trn ? 'company' : 'roe',
              },
              'session'
            );
          }
          let mergeOrgData = {};
          if (res?.data?.getMyProfile?.org?.orgRole === 'BUSSINESS_ORG') {
            mergeOrgData = {
              ...res?.data?.getMyProfile?.org,
              // primaryContactNo: res?.data?.getMyProfile?.primaryContactNo,
            };
          } else {
            mergeOrgData = { ...res?.data?.getMyProfile };
          }
          //const data = this.formatBranch(res?.data?.getMyOrgProfile);
          if (appno) {
            console.log('jksgdsdghjk', getapp);
            return {
              ...this.format(
                mergeOrgData,
                res?.data?.getMyProfile?.role,
                getapp
              ),
            };
          }
          return {
            ...this.format(mergeOrgData, res?.data?.getMyProfile?.role),
          };
        }
      }
    } catch (err: any) {
      console.log(err);
      throw err;
    }
  }

  private formatBranch(data: any) {
    let _data;
    if (data?.branches) {
      _data = {
        ...data?.branches?.[0],
        ...data,
        branches: data?.branches?.slice(1),
      };
    }
    if (data?.companyType) {
      _data = { ..._data, companyType: data?.companyType?.name };
    }
    if (data?.companyStatus) {
      _data = { ..._data, companyStatus: data?.companyStatus?.name };
    }
    console.log('ppi->', data?.branches, _data);
    return _data;
  }

  private getOrgListItems(res: any) {
    console.log('getOrgListItems', res);
    let _temp = [];
    const {
      address,
      primaryContactNo,
      registrationNo,
      email,
      name,
      incorporationDate,
      website,
      firstName,
      lastName,
      createdAt,
      org,
      tccNumber,
      tccExpiryDate,
    } = res;
    // const {
    //   setUpApplicationNo,
    //   natureOfBusiness
    // } = org;
    const setUpApplicationNo = org?.setUpApplicationNo;
    const natureOfBusiness = org?.natureOfBusiness;
    const _roeCompanyName = org?.name;
    // const {
    //   addressLine1,
    //   addressLine2,
    //   addressLine3,
    //   city,
    //   country,
    //   state,
    //   zipcode,
    // } = address ?? {};
    _temp = featuresSection?.orgListItems?.map((item) => {
      if (registrationNo && item?.title === 'Company Registration No') {
        return {
          ...item,
          subTitle: registrationNo ?? '-',
        };
      }
      if (setUpApplicationNo && item?.title === 'Application No') {
        return {
          ...item,
          subTitle: setUpApplicationNo ?? '-',
        };
      }

      if (name && item?.title === 'Business Name') {
        return {
          ...item,
          subTitle: name ?? '-',
        };
      }
      if (_roeCompanyName && item?.title === 'Business Name') {
        return {
          ...item,
          subTitle: _roeCompanyName ?? '-',
        };
      }
      if (natureOfBusiness && item?.title === 'Nature of Business') {
        return {
          ...item,
          subTitle: natureOfBusiness.split(':')[1] ?? '-',
        };
      }
      if (incorporationDate && item?.title === 'Incorporation Date') {
        return {
          ...item,
          subTitle: incorporationDate ?? '-',
        };
      }
      if (createdAt && item?.title === 'Created At') {
        return {
          ...item,
          subTitle: createdAt ?? '-',
        };
      }

      if (tccNumber && item?.title === 'TCC No') {
        return {
          ...item,
          subTitle: tccNumber ?? '-',
        };
      }
      if (tccExpiryDate && item?.title === 'TCC Expiry Date') {
        return {
          ...item,
          subTitle: tccExpiryDate ?? '-',
        };
      }
    });
    return _temp || [];
  }

  private getListItems(res: any) {
    let _temp = [];
    _temp = featuresSection?.listItems?.map((item) => {
      if (item?.title === 'Business Name') {
        return {
          ...item,
          subTitle: res?.businessName
            ? `${toHeaderCase(res?.businessName)}`
            : '-',
        };
      }

      if (item?.title === 'Company Registration No') {
        return {
          ...item,
          subTitle: res?.registrationNumber ?? '-',
        };
      }

      if (item?.title === 'Status') {
        return {
          ...item,
          subTitle:
            res?.companyStatus === 'underReview' ? 'Under Review' : 'active',
        };
      }
    });
    return _temp;
  }

  private getDirectorData = (res: any) => {
    console.log('asdfasdf', res, Object.keys(res));
    let _temp = [],
      _temp1: any = [];
    _temp =
      Object.keys(res)?.length > 0
        ? Object.keys(res)?.map((item: any, key: number) => {
            // if(item==='branches')
            if (item === 'lastName')
              console.log('ppjram->', item, res?.[item], typeof res?.[item]);
            if (res?.[item] && typeof res?.[item] !== 'object') {
              if (item === 'lastName') console.log('ppjram-->1stcase');
              return {
                title: `${item}`,
                subTitle: `${res?.[item]}` ?? '',
                // subTitle: `${toHeaderCase(item?.firstName ?? '')} ${toHeaderCase(
                //   item?.middleName ?? ''
                // )} ${toHeaderCase(item?.lastName ?? '')}`,
              };
            } else if (res?.[item]) {
              if (item === 'lastName') console.log('ppjram-->2ndcase');
              console.log('Asdfasdfasdf', res?.[item]);
              _temp1 =
                Object.keys(res?.[item])?.length > 0
                  ? Object.keys(res?.[item])?.map((subItem: any) => {
                      if (res?.[item]?.[subItem])
                        return {
                          title: `${subItem}`,
                          subTitle: `${res?.[item]?.[subItem]}` ?? '',
                        };
                    })
                  : [];
            } else {
              if (item === 'lastName') console.log('ppjram-->3rdcase');
              return null;
            }
          })
        : [];
    console.log(
      'pp->tot',
      [..._temp, ..._temp1].filter((i) => i !== null)
    );
    return [..._temp, ..._temp1].filter((i) => i !== null && i !== undefined);
  };

  private getBranchData = (res: any) => {
    let _temp = [];
    _temp = res?.map((item: any, key: number) => {
      console.log('pp->', item);
      return {
        title: `Branch ${key + 1}`,
        subTitle: `${toHeaderCase(item?.name ?? '')}`,
      };
    });
    console.log('pp->', _temp, res);
    return _temp;
  };
  private getDirData = (res: any) => {
    let _temp = [];
    _temp = res?.map((item: any, key: number) => {
      console.log('pp->', item);
      return {
        title: `Director ${key + 1}`,
        subTitle: `${toHeaderCase(item?.name ?? '')}`,
      };
    });
    console.log('pp->', _temp, res);
    return _temp;
  };

  private getSubsidiaryData = (res: any) => {
    let _temp = [];
    _temp = res?.map((item: any, key: number) => {
      console.log('pp->', item);
      return {
        title: `Subsidiary ${key + 1}`,
        subTitle: `${toHeaderCase(item?.name ?? '')}`,
      };
    });
    console.log('pp->', _temp, res);
    return _temp;
  };

  private getType = (type: string) => {
    if (type) {
      const arr: any = {
        PUBLIC: 'Public',
        NGO: 'Non-governmental Organization',
        DIPLOMAT: 'Diplomat',
        PRIVATE_INDIVIDUAL: 'Private Individual',
        NON_GOVERNMENTAL: 'Non Governmental',
        PRIVATE_COMPANY: 'Private Company',
        GOVERNMENT: 'Government',
      };
      return arr[type];
    }
    return '-';
  };
  private getApplicantData = (res: any) => {
    console.log('sddfsdfsfwe', res);
    let _temp = [];
    const {
      address,
      countryOfBirth,
      dataOfBirth,
      email,
      firstName,
      gender,
      intendedAddress,
      lastName,
      maritalStatus,
      middleName,
      nationality,
      natureOfBusiness,
      occupation,
      passportExpiry,
      passportNumber,
      placeOfBirth,
      primaryContactNo,
      qualification,
    } = res;
    const { addressLine1, addressLine2, city } = address ?? {};
    const { degree } = qualification;
    const __temp: any = [];
    _temp = featuresSection?.applicantItems?.map((item) => {
      if (firstName && item?.title === 'First Name') {
        __temp.push({
          ...item,
          subTitle: firstName ? `${firstName}` : '-',
        });
      }
      if (lastName && item?.title === 'Last Name') {
        __temp.push({
          ...item,
          subTitle: lastName ? `${lastName}` : '-',
        });
      }
      if (email && item?.title === 'Middle Name') {
        __temp.push({
          ...item,
          subTitle: middleName ? `${middleName}` : '-',
        });
      }
      if (email && item?.title === 'Email') {
        __temp.push({
          ...item,
          subTitle: email ? `${email}` : '-',
        });
      }
      if (address?.addressLine1 && item?.title === 'Address Line 1') {
        __temp.push({
          ...item,
          subTitle: address?.addressLine1 ? `${address?.addressLine1}` : '-',
        });
      }
      if (address?.addressLine2 && item?.title === 'Address Line 2') {
        __temp.push({
          ...item,
          subTitle: address?.addressLine2 ? `${address?.addressLine2}` : '-',
        });
      }
      if (address?.city && item?.title === 'City/Town') {
        __temp.push({
          ...item,
          subTitle: address?.city ? `${address?.city}` : '-',
        });
      }
      if (countryOfBirth && item?.title === 'Country of Birth') {
        __temp.push({
          ...item,
          subTitle: countryOfBirth ? `${countryOfBirth}` : '-',
        });
      }
      if (placeOfBirth && item?.title === 'Place of Birth') {
        __temp.push({
          ...item,
          subTitle: placeOfBirth ? `${placeOfBirth}` : '-',
        });
      }
      if (dataOfBirth && item?.title === 'Date of Birth') {
        __temp.push({
          ...item,
          subTitle: dataOfBirth ? `${dataOfBirth}` : '-',
        });
      }
      if (gender && item?.title === 'Gender') {
        __temp.push({
          ...item,
          subTitle: gender ? `${gender}` : '-',
        });
      }
      if (maritalStatus && item?.title === 'Marital Status') {
        __temp.push({
          ...item,
          subTitle: maritalStatus ? `${maritalStatus}` : '-',
        });
      }
      if (occupation && item?.title === 'Occupation') {
        __temp.push({
          ...item,
          subTitle: occupation ? `${occupation}` : '-',
        });
      }
      if (nationality && item?.title === 'Nationality') {
        __temp.push({
          ...item,
          subTitle: nationality ? `${nationality}` : '-',
        });
      }
      if (natureOfBusiness && item?.title === 'Nature Of Business') {
        __temp.push({
          ...item,
          subTitle: natureOfBusiness ? `${natureOfBusiness}` : '-',
        });
      }
      if (passportNumber && item?.title === 'Passport Number') {
        __temp.push({
          ...item,
          subTitle: passportNumber ? `${passportNumber}` : '-',
        });
      }
      if (primaryContactNo && item?.title === 'Primary Contact No') {
        __temp.push({
          ...item,
          subTitle: primaryContactNo ? `${primaryContactNo}` : '-',
        });
      }
      if (passportExpiry && item?.title === 'Passport Expiry') {
        __temp.push({
          ...item,
          subTitle: passportExpiry ? `${passportExpiry}` : '-',
        });
      }
      if (
        intendedAddress?.addressLine1 &&
        item?.title === 'Operating Address'
      ) {
        __temp.push({
          ...item,
          subTitle: intendedAddress?.addressLine1
            ? `${intendedAddress?.addressLine1}`
            : '-',
        });
      }
    });
    console.log('response--->', res);
    return __temp;
  };
  private getCompanyData = (res: any) => {
    console.log('getcomanydata', res);
    let _temp = [];
    const {
      address,
      primaryContactNo,
      trn,
      type,
      email,
      natureOfBusiness,
      name,
      website,
      incorporationDate,
      firstName,
      lastName,
      countryOfBirth,
      dateOfBirth,
      maritalStatus,
      nationality,
      occupation,
    } = res;
    // const {
    //   addressLine1,
    //   addressLine2,
    //   addressLine3,
    //   city,
    //   country,
    //   parish,
    //   state,
    //   zipcode,
    // } = address ?? {};
    const __temp: any = [];
    _temp = featuresSection?.companyListItems?.map((item) => {
      console.log('getcompanydata--ressss', item);
      if (address?.addressLine1 && item?.title === 'Street 1') {
        __temp.push({
          ...item,
          subTitle: address?.addressLine1 ? `${address?.addressLine1}` : '-',
        });
      }
      if (address?.addressLine2 && item?.title === 'Street 2') {
        __temp.push({
          ...item,
          subTitle: address?.addressLine2 ? `${address?.addressLine2}` : '-',
        });
      }
      if (incorporationDate && item?.title === 'Incorporation Date') {
        __temp.push({
          ...item,
          subTitle: incorporationDate ?? '-',
        });
      }
      if (firstName && item?.title === 'First Name') {
        __temp.push({
          ...item,
          subTitle: firstName ?? '-',
        });
      }
      if (lastName && item?.title === 'Last Name') {
        __temp.push({
          ...item,
          subTitle: lastName ?? '-',
        });
      }
      if (countryOfBirth && item?.title === 'Country of Birth') {
        __temp.push({
          ...item,
          subTitle: countryOfBirth ?? '-',
        });
      }
      if (dateOfBirth && item?.title === 'Date of Birth') {
        __temp.push({
          ...item,
          subTitle: dateOfBirth ?? '-',
        });
      }
      if (maritalStatus && item?.title === 'Marital Status') {
        __temp.push({
          ...item,
          subTitle: maritalStatus ?? '-',
        });
      }
      if (nationality && item?.title === 'Nationality') {
        __temp.push({
          ...item,
          subTitle: nationality ?? '-',
        });
      }
      if (occupation && item?.title === 'Occupation') {
        __temp.push({
          ...item,
          subTitle: occupation ?? '-',
        });
      }
      if (natureOfBusiness && item?.title === 'Nature of Business') {
        __temp.push({
          ...item,
          subTitle: natureOfBusiness
            ? natureOfBusiness?.includes(':')
              ? natureOfBusiness?.split(':')?.[1]
              : `${natureOfBusiness}`
            : '-',
        });
      }
      if (address?.parish && item?.title === 'Parish') {
        __temp.push({
          ...item,
          subTitle: address?.parish ?? '-',
        });
      }
      console.log('_____temp--website', website);
      if (website && item?.title === 'Website') {
        __temp.push({
          ...item,
          subTitle: website ?? '-',
        });
      }
      if (trn && item?.title === 'Taxpayer Registration No') {
        __temp.push({
          ...item,
          subTitle: trn ?? '-',
        });
      }
      if (type && item?.title === 'Company Type') {
        __temp.push({
          ...item,
          subTitle: this.getType(type),
        });
      }
      if (address?.zipcode && item?.title === 'Postal Code') {
        __temp.push({
          ...item,
          subTitle: address?.zipcode ?? '-',
        });
      }
      if (primaryContactNo && item?.title === 'Phone Number') {
        __temp.push({
          ...item,
          subTitle: primaryContactNo ?? '-',
        });
      }

      if (address?.city && item?.title === 'City/Town') {
        __temp.push({
          ...item,
          subTitle: address?.city ?? '-',
        });
      }
    });
    console.log('_____temp', __temp);
    return __temp;
  };
  private renderIf = (data: any, ele: any) => {
    console.log(data, 'lo->');
    if (Array.isArray(data) && data.length > 0) {
      return [ele];
    }
    return [];
  };
  private _getProfileData(_res: any, doc?: any) {
    let docs = doc && doc?.documents;
    console.log('jskdfhsdfhsdkj');
    let navItems: any = [
      {
        key: 'company-details',
        title: 'Company Details',
        link: '/company-details',
        type: 'navbar',
      },

      ...this.renderIf(this.getBranchData(_res?.branches), {
        key: 'branches',
        title: 'Branches',
        link: '/branches',
        type: 'navbar',
      }),
      ...this.renderIf(this.getSubsidiaryData(_res?.subsidiaries), {
        key: 'subsidiaries',
        title: 'Subsidiaries',
        link: '/subsidiaries',
        type: 'navbar',
      }),
      ...this.renderIf(doc && this.getApplicantData(doc?.applicantInfo), {
        key: 'applicant-details',
        title: 'Applicant Details',
        link: '/applicant-details',
        type: 'navbar',
      }),
      ...this.renderIf(this.getDirData(_res?.directors), {
        key: 'directors',
        title: 'Directors',
        link: '/directors',
        type: 'navbar',
      }),
      ...this.renderIf(
        docs
          ? this.getCarouselItems(docs)
          : this.getCarouselItems(_res.documents),
        {
          key: 'documents',
          title: 'Documents',
          link: '/documents',
          type: 'navbar',
        }
      ),
      //   ...specialNavItems,
      //   ...renderIf(evidenceData, {
      //     key: 'appeal-details',
      //     title: 'Appeal details',
      //     link: '/appeal-details',
      //     type: 'navbar',
      //   }),
      //   ...renderIf(timelinedata, {
      //     key: 'timeline',
      //     title : 'Timeline',
      //     link: '/timeline',
      //     type: 'navbar',
      //   })
    ];
    return {
      navItems: navItems,
      activeKey: 'company-details',
      isDetail: true,
      isNoProfileExist: true,
    };
  }
  private getItemSpecData(_res: any) {
    console.log('getItemSpecData', _res);
    let profileData = {
      ...this.statusComp2(_res?.status, _res?.reason),
      banner: 'https://i.ibb.co/KsQpvWk/wepik-export-20230718124224lfml.png',
      profileImage: 'https://i.ibb.co/k6hxpL1p/image.png',
      name: _res.name || _res?.lastName + ', ' + _res?.firstName,
    };
    return { profileData: profileData };
  }
  private _renderAccordion(_res: any, doc?: any) {
    console.log('resssssss', _res, doc);
    let docs = doc && doc?.documents;
    let res: any = [
      {
        type: 'multi-col-list',
        numberOfColumns: '3',
        title: 'Company Details',
        key: 'company-details',
        data: this.getCompanyData(_res),
      },
    ];
    // console.log("asdjasdfj",this.getCompanyData(_res),this.getApplicantData(doc?.applicantInfo));
    let res_app: any = [
      {
        type: 'multi-col-list',
        numberOfColumns: '3',
        title: 'Applicant Details',
        key: 'applicant-details',
        data: doc ? this.getApplicantData(doc?.applicantInfo) : null,
      },
    ];
    if (
      doc &&
      doc?.applicantInfo &&
      this.getApplicantData(doc?.applicantInfo)
    ) {
      res = [...res, ...res_app];
    }

    // res = [
    //   {
    //     type: 'multi-col-list',
    //     numberOfColumns: '3',
    //     title: 'Company Details',
    //     data: this.getCompanyData(_res),
    //   },
    // ];

    if (Array.isArray(_res?.directors) && _res?.directors?.length !== 0) {
      res = [
        ...res,
        {
          type: 'accordion',
          numberOfColumns: '3',
          title: 'Directors List',
          key: 'directors',
          data: _res?.directors?.map((data: any, key: any) => {
            return {
              type: 'multi-col-list',
              title: `Director ${key + 1}`,
              numberOfColumns: '3',
              data: this.getDirectorData(data),
            };
          }),
          // data: this.getDirectorData(_res?.directors),
        },
      ];
    }
    if (Array.isArray(_res?.branches) && _res?.branches?.length !== 0) {
      res = [
        ...res,

        {
          type: 'accordion',
          numberOfColumns: '3',
          title: 'Branches List',
          key: 'branches',
          data: _res?.branches?.map((data: any, key: any) => {
            return {
              type: 'multi-col-list',
              title: `Branche ${key + 1}`,
              numberOfColumns: '3',
              data: this.getDirectorData(data),
            };
          }),
          // data: this.getDirectorData(_res?.directors),
        },
      ];
    }
    if (Array.isArray(_res?.subsidiaries) && _res?.subsidiaries?.length !== 0) {
      res = [
        ...res,

        {
          type: 'accordion',
          numberOfColumns: '3',
          title: 'Subsidiary List',
          key: 'subsidiaries',
          data: _res?.subsidiaries?.map((data: any, key: any) => {
            return {
              type: 'multi-col-list',
              title: `Subsidiary ${key + 1}`,
              numberOfColumns: '3',
              data: this.getDirectorData(data),
            };
          }),
          // data: this.getDirectorData(_res?.directors),
        },
      ];
    }
    if (this.getCarouselItems(_res.documents) || this.getCarouselItems(docs)) {
      res = [
        ...res,
        {
          type: 'media-carousel',
          key: 'documents',
          data: docs
            ? this.getCarouselItems(docs)
            : this.getCarouselItems(_res.documents),
        },
      ];
    }
    console.log('asldjkfadjkl', res);
    return res;
  }

  private getCarouselItems(documents: any[]) {
    console.log('osaudfsydfuasdf', documents);
    let temp: any[] = [];
    documents &&
      Array.isArray(documents) &&
      documents?.length > 0 &&
      documents?.forEach((doc) => {
        if (!doc) {
        } else if (doc.fileType === 'application/pdf') {
          temp.push({
            src: doc.src,
            poster: doc.poster,
            type: 'pdf',
            title: doc.name,
          });
        } else {
          temp.push({
            src: doc.src,
            poster: doc.poster,
            type: 'img',
            title: doc.name,
          });
        }
      });

    return temp;
  }

  private getButtons = (status: any) => {
    console.log('Sttus', status);
    let _buttons: any = [];
    if (status === 'ACCEPTED') {
      _buttons.push({
        key: 'edit',
        title: 'Edit Profile',
        color: 'primary',
      });
    }
    if (status === 'DOCUMENTATION_REJECTED') {
      _buttons.push({
        key: 'docRejected',
        title: 'Update Documents',
        color: 'primary',
      });
    }
    return _buttons;
  };

  private statusComp = (status: any, reason: string) => {
    if (status === 'ACCEPTED') {
      return {
        title: `Active`,
        statusType: 'success',
      };
    }
    if (status === 'APPROVAL_PENDING') {
      return {
        title: `Approval Pending`,
        statusType: 'warning',
      };
    }
    if (status === 'DOCUMENTATION_REJECTED') {
      return {
        title: reason,
        statusType: 'danger',
      };
    }
    if (status === 'DENIED') {
      return {
        title: `Denied : ${reason}`,
        statusType: 'danger',
      };
    }
    if (status === 'INTERPOL_CHECK') {
      return {
        title: `${'Interpol Check'}`,
        statusType: 'warning',
      };
    }
    if (status === 'PROCESSING_OFFICER_SUPERVISOR_REVIEW') {
      return {
        title: `${'Processing officer supervisor review'}`,
        statusType: 'warning',
      };
    }
    if (status === 'PROCESSING_OFFICER_SUPERVISOR_REVIEW_INVESTIGATION') {
      return {
        title: `${'Processing officer supervisor review investigation'}`,
        statusType: 'warning',
      };
    }
    if (status === 'DIRECTOR_REVIEW_INVESTIGATION') {
      return {
        title: `${'Director review investigation'}`,
        statusType: 'warning',
      };
    }
    if (status === 'DIRECTOR_REVIEW') {
      return {
        title: `${'Director review'}`,
        statusType: 'warning',
      };
    }
    if (status === 'INVESTIGATING_SUPERVISOR_REVIEW') {
      return {
        title: `${'Investigation Supervisor review'}`,
        statusType: 'warning',
      };
    }
  };

  private statusComp2 = (status: any, reason: string) => {
    if (status === 'ACCEPTED') {
      return {
        badge: `Active`,
        badgeColor: 'green',
      };
    }
    if (status === 'APPROVAL_PENDING') {
      return {
        badge: `Approval Pending`,
        badgeColor: 'orange',
      };
    }
    if (status === 'DOCUMENTATION_REJECTED') {
      return {
        badge: `Documentation Rejected :${reason}`,
        badgeColor: 'danger',
      };
    }
    if (status === 'DENIED') {
      return {
        badge: `Denied : ${reason}`,
        badgeColor: 'danger',
      };
    }
    if (status === 'INTERPOL_CHECK') {
      return {
        badge: `${'Interpol Check'}`,
        badgeColor: 'orange',
      };
    }
    if (status === 'PROCESSING_OFFICER_SUPERVISOR_REVIEW') {
      return {
        badge: `${'Processing officer supervisor review'}`,
        badgeColor: 'orange',
      };
    }
    if (status === 'PROCESSING_OFFICER_SUPERVISOR_REVIEW_INVESTIGATION') {
      return {
        badge: `${'Processing officer supervisor review investigation'}`,
        badgeColor: 'orange',
      };
    }
    if (status === 'DIRECTOR_REVIEW_INVESTIGATION') {
      return {
        badge: `${'Director review investigation'}`,
        badgeColor: 'orange',
      };
    }
    if (status === 'DIRECTOR_REVIEW') {
      return {
        badge: `${'Director review'}`,
        badgeColor: 'orange',
      };
    }
    if (status === 'INVESTIGATING_SUPERVISOR_REVIEW') {
      return {
        badge: `${'Investigation Supervisor review'}`,
        badgeColor: 'orange',
      };
    }
  };

  private directorData = (data: any) => {
    let dirRes: any = [];
    data &&
      Array.isArray(data) &&
      data?.length > 0 &&
      data?.map((item) => {
        dirRes.push({
          ...item,
          exist: true,
          id: uuidv4(),
        });
      });
    console.log('ffr', dirRes);
    return dirRes;
  };

  private format = (_res: any, role: any, doc?: any) => {
    console.log('ppi->2jram', _res, doc);
    let _isDirectors;
    let docs = doc && doc?.documents;
    return {
      tccExpiry: _res?.tccExpiryDate,
      // tccExpiry:"2020-03-29",

      itemspecmarsData: this.getItemSpecData(_res),
      itemSpecData: doc
        ? this._renderAccordion(_res, doc)
        : this._renderAccordion(_res),
      profileData: doc
        ? this._getProfileData(_res, doc)
        : this._getProfileData(_res),
      // accordionItems: this._renderAccordion(_res),
      // organizationProfile: {
      type: _res?.org?.orgRole,
      appno: doc ? doc?.applicationNo : '-',
      title: _res?.name || _res?.lastName + ', ' + _res.firstName,
      // subtitle: _res?.description,
      isRegistered: _res?.status === 'INVITED' ? true : false,
      status: _res?.status || _res?.org?.status,
      initialData: {
        addressLine1: _res?.address?.addressLine1,
        addressLine2: _res?.address?.addressLine2,
        parish: _res?.address?.parish,
        city: _res?.address?.city,
        zipcode: _res?.address?.zipcode,
        primaryContactNo: _res?.primaryContactNo,
        directors: this.directorData(_res?.directors),
        subsidiaries: this.directorData(_res?.subsidiaries),
        branches: this.directorData(_res?.branches),
        role: role?.[0]?.name,
      },
      heroImage: {
        image: _res?.logo ?? `https://i.ibb.co/wdHPKr8/organization.png`,
      },
      listItems: this.getOrgListItems(_res),
      // carouselItems: this.getCarouselItems(_res?.documents),
      buttons: this.getButtons(_res?.status || (doc && doc?.status)),
      // buttons: this.getButtons("DOCUMENTATION_REJECTED"),
      statusComp: this.statusComp(
        _res?.status || _res?.org?.status,
        _res?.reason
      ),
      StatusCompp: doc ? this.statusComp(doc?.status, doc?.comment) : null,
      appstatus: doc?.status,
      iscomment: true,
      comment: doc?.comment,
      // statusCompp: this.statusComp(

      // ),
      // statusComp: this.statusComp("DOCUMENTATION_REJECTED"),
      formDefaultData: {
        name: _res?.name,
        description: _res?.description,
        image: _res?.logo,
        address: _res?.address?.addressLine1,
        country: _res?.address?.country,
        city: _res?.address?.city,
        telephone: _res?.primaryContactNo,
        website: _res?.website,
        parish: _res?.address?.parish,
      },
      //},
    };
  };
}
